import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { ApiService } from '../../services/API/api.service';
import { AlertService } from '../../services/Alert/alert.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import * as $ from 'jquery';
import { HttpErrorResponse } from '@angular/common/http';

@Component({
  selector: 'app-account',
  templateUrl: './account.component.html',
  styleUrl: './account.component.scss'
})
export class AccountComponent implements OnInit {

  accountForm: FormGroup
  passwordForm: FormGroup
  profileImage: FormGroup
  newAddressForm: FormGroup;

  isLoading: boolean = false;

  constructor(private apiService: ApiService,private alertService: AlertService,private fb: FormBuilder) {
    this.accountForm = this.fb.group({
      name: ['', [Validators.required]],
      phone: ['', [Validators.required]],
      sec_phone: [''],
      gender: ['', [Validators.required]],
      lang: ['en', [Validators.required]]
    });

    this.profileImage = this.fb.group({
      profileImage: [null]
    });

    this.newAddressForm = this.fb.group({
      country_id: ['', Validators.required],
      city_id: ['', Validators.required],
      address: ['', Validators.required],
      building: [''],
      floor: [''],
      flat: [''],
      special_mark: [''],
      latitude: [''],
      longitude: ['']
    });
  }

  ngOnInit(): void {
    const token = localStorage.getItem('fontana_token')?.toString();
    this.allCountriesFunction()
    if(token){
      this.myProfileFunction();
      this.myOrdersFunction();
      this.myAddressesFunction();
    }
    // this.initMap();
    this.initAutocomplete();
  }

  @ViewChild('fileInput') fileInput!: ElementRef;
  profileImagePreview: string | ArrayBuffer | null = null;
  // uploadError: string | null = null;
  onFileSelected(event: Event): void {
    const input = event.target as HTMLInputElement;
    if (!input.files || input.files.length === 0) return;

    const file = input.files[0];
    
    // Validate file type and size (example: 2MB max)
    if (!file.type.match('image.*')) {
      // this.uploadError = 'Only image files are allowed';
      this.resetFileInput();
      return;
    }

    // if (file.size > 2 * 1024 * 1024) {
    //   // this.uploadError = 'Image size should be less than 2MB';
    //   this.resetFileInput();
    //   return;
    // }

    // this.uploadError = null;
    // this.isLoading = true;

    // Create preview
    const reader = new FileReader();
    reader.onload = () => {
      this.profileImagePreview = reader.result;
    };
    reader.readAsDataURL(file);

    // Upload immediately
    this.uploadProfileImage(file);
  }

  private uploadProfileImage(file: File): void {
    const formData = new FormData();
    formData.append('profileImage', file,file.name);
    console.log(formData.get('profileImage'));
    for (let [key, value] of formData.entries()) {
      console.log(key, value);
    }

    this.apiService.changeProfileImage(formData).subscribe({
      next: (response) => {
        // this.isLoading = false;
        this.alertService.success('Profile image updated successfully!');
        // Update the profile image in your profileDetails
        if (response.data?.avatar) {
          this.profileDetails.avatar = response.data.avatar;
        }
      },
      error: (error) => {
        // this.isLoading = false;
        // this.uploadError = error.error?.message || 'Failed to update profile image';
        this.resetFileInput();
      }
    });
  }

  private resetFileInput(): void {
    this.profileImagePreview = null;
    this.fileInput.nativeElement.value = '';
  }

  removeProfileImage(){
    this.apiService.deleteProfileImage().subscribe({
      next: response => {
        if(response.success == true){
          this.alertService.success(response.message);
          setTimeout(() => {
            this.profileImagePreview = null;
            this.myProfileFunction();
            this.profileDetails.value.avatar = null;
          }, 1500);
        }
      }, 
      error: (error: any) => {
        this.alertService.danger(error.error.message);
      }
    });
  }

  profileDetails: any
  myProfileFunction(){
    this.isLoading = true;
    this.apiService.myProfile().subscribe({
      next: response => {
        // console.log(response.data);
        this.profileDetails = response.data;
        const phone = this.formatPhoneForDisplay(this.profileDetails.phone);
        const sec_phone = this.formatPhoneForDisplay(this.profileDetails.sec_phone);
        this.accountForm.patchValue({
          name: this.profileDetails.name,
          phone: phone,
          sec_phone: sec_phone,
          gender: this.profileDetails.gender,
          lang: this.profileDetails.lang
        });
        this.isLoading = false;
      }, 
      error: (error: any) => {
        this.alertService.danger(error.error.message);
      }
    });
  }

  myOrders: any
  ordersLength: number = 0;
  myOrdersFunction(){
    this.apiService.myOrders().subscribe({
      next: response => {
        this.myOrders = response.data;
        this.ordersLength = response.data.length;
        // console.log(response.data);
      }, 
      error: (error: any) => {
        this.alertService.danger(error.error.message);
      }
    });
  }

  myAddresse: any
  addressesLength: number = 0
  allAddresses: any
  myAddressesFunction(){
    this.isLoading = true;
    this.apiService.myAddresses().subscribe({
      next: response => {
        // console.log(response.data);
        this.myAddresse = response.data.myAddresses[0].address;
        this.allAddresses = response.data.myAddresses;
        this.addressesLength = response.data.myAddresses.length;
        // console.log(this.allAddresses);
        this.isLoading = false;
      }, 
      error: (error: any) => {
        this.alertService.danger(error.error.message);
        this.allAddresses = [];
        this.isLoading = false;
      }
    });
  }
   setAsMain(addressId: number): void {
    if (this.isLoading) return;
    
    // Find if there's already a main address
    const currentMainAddress = this.allAddresses?.find(a => a.isMain);
    
    // Prevent unnecessary API call if already main
    if (currentMainAddress && currentMainAddress.id === addressId) {
      this.alertService.danger('This is already your main address');
      return;
    }

    this.isLoading = true;
    this.apiService.setMainAddress(addressId).subscribe({
      next: () => {
        // Update UI optimistically
        this.allAddresses = this.allAddresses?.map(address => ({
          ...address,
          isMain: address.id === addressId
        })) || null;
        
        this.alertService.success('Main address updated successfully');
        this.isLoading = false;
      },
      error: (error) => {
        this.alertService.danger(error.error?.message || 'Failed to update main address');
        this.isLoading = false;
      }
    });
  }
  deleteAddress(addressId: number): void {
    if (confirm('Are you sure you want to delete this address?')) {
      this.apiService.deleteAddress(addressId).subscribe({
        next: () => {
          this.alertService.success('Address deleted successfully');
          this.myAddressesFunction(); // Refresh the list
        },
        error: (error) => {
          this.alertService.danger(error.error?.message || 'Failed to delete address');
        }
      });
    }
  }

  allCountries: any
  countriesLength: number = 0
  allCountriesFunction(){
    this.isLoading = true;
    this.apiService.countries(1).subscribe({
      next: response => {
        this.allCountries = response.data;
        this.countriesLength = this.allCountries.length;
        console.log(this.allCountries);
        this.isLoading = false;
      }, 
      error: (error: any) => {
        this.alertService.danger(error.error.message);
        this.allCountries = [];
        this.isLoading = false;
      }
    });
  }
  selectedCountryId: number | null = null;
  cities: any[] = [];
  citySelected: boolean = false;
  onCountryChange(countryId: any) {
    // console.log(countryId.value);
    this.selectedCountryId = countryId.value;
    const selectedCountry = this.allCountries.find(c => c.id == this.selectedCountryId);
    // console.log(selectedCountry);
    this.cities = selectedCountry ? selectedCountry.cities : [];
    // console.log(this.cities);
    // this.newAddressForm.get('city_id')?.reset();
    this.citySelected = true;
  }


  changePasswordToggle: boolean = false;
  isSavingPassword: boolean = false;
  initializePasswordForm() {
    this.passwordForm = this.fb.group({
      old_password: ['', [Validators.required]],
      new_password: ['', [Validators.required, Validators.minLength(8)]],
      new_password_confirmation: ['', [Validators.required]]
    }, { validator: this.passwordMatchValidator });
  }

  // Custom validator to check if passwords match
  passwordMatchValidator(formGroup: FormGroup) {
    const newPassword = formGroup.get('new_password')?.value;
    const confirmPassword = formGroup.get('new_password_confirmation')?.value;
    
    return newPassword === confirmPassword ? null : { mismatch: true };
  }

  togglePasswordForm() {
    this.changePasswordToggle = !this.changePasswordToggle;
    if (this.changePasswordToggle) {
      this.initializePasswordForm();
    }
  }

  submitPasswordForm() {
    this.passwordForm.markAllAsTouched();
    
    if (this.passwordForm.invalid) {
      this.alertService.danger('Please fill all required fields correctly');
      return;
    }

    if (this.passwordForm.hasError('mismatch')) {
      this.alertService.danger('New passwords do not match');
      return;
    }

    this.isSavingPassword = true;
    
    this.apiService.changePassword(this.passwordForm.value).subscribe({
      next: response => {
        this.isSavingPassword = false;
        if (response.success) {
          this.alertService.success(response.message);
          setTimeout(() => {
            this.changePasswordToggle = false;
            // Optional: reset form
            this.passwordForm.reset();
          }, 1500);
        }
      }, 
      error: (error: any) => {
        this.isSavingPassword = false;
        this.alertService.danger(error.error.message || 'Failed to change password');
      }
    });
  }

  @ViewChild('deleteAccountModal') deleteAccountModal!: ElementRef;
  deleteConfirmed: boolean = false;
  deleteAccount(){
    this.apiService.deleteAccount().subscribe({
      next: response => {
        if(response.success == true){
          this.alertService.success(response.message);
          setTimeout(() => {
            this.apiService.logout();
          }, 1500);
        }
      }, 
      error: (error: any) => {
        this.alertService.danger(error.error.message);
      }
    });
  }

  changeProfileData(){
    // console.log(this.accountForm);
    if(this.accountForm.get('sec_phone')?.value == undefined || this.accountForm.get('sec_phone')?.value == null){
      this.accountForm.patchValue({
        sec_phone: ''
      })
    }

    const rawPhone = this.accountForm.get('phone')?.value.replace(/\D/g, '');
    const rawPhone2 = this.accountForm.get('sec_phone')?.value.replace(/\D/g, '');
    this.accountForm.patchValue({ phone: rawPhone, sec_phone: rawPhone2 });

    if(this.accountForm.valid){
      this.apiService.myProfileUpdate(this.accountForm.value).subscribe({
        next: response => {
          // console.log(response.data);
          if(response.success == true){
            this.alertService.success(response.message);
            setTimeout(() => {
              window.location.reload();
            }, 1500);
          }
        }, 
        error: (error: any) => {
          this.alertService.danger(error.error.message);
          const phone = this.formatPhoneForDisplay(this.profileDetails.phone);
          const sec_phone = this.formatPhoneForDisplay(this.profileDetails.sec_phone);
          this.accountForm.patchValue({
            phone: phone,
            sec_phone: sec_phone
          });
        }
      });
    }
  }

  cancelOrder(orderId: number) {
    if(orderId){
      this.apiService.cancelOrder(orderId).subscribe({
        next: (response) => {
          if(response.success == true){
            this.myOrdersFunction()
            this.alertService.success(response.message);
          }else{
            this.alertService.danger(response.message);
          }
          // console.log(response)
        }, error: (error: HttpErrorResponse) => {
          console.log(error)
          this.alertService.danger(error.error.message);
        }
      })
    }
  }
  
  reorder(orderId: number) {
    // console.log('Reordering:', orderId);
    if(orderId){
      this.apiService.reorderOrder(orderId).subscribe({
        next: (response) => {
          // console.log(response)
          if(response.success == true){
            this.myOrdersFunction()
            this.alertService.success(response.message);
          }else{
            this.alertService.danger(response.message);
          }
        }, error: (error: HttpErrorResponse) => {
          this.alertService.danger(error.error.message);
        }
      })
    }
  }
  
  deleteOrder(orderId: number) {
    if(orderId){
      this.apiService.deleteOrder(orderId).subscribe({
        next: (response) => {
          // console.log(response)
          if(response.success == true){
            this.myOrdersFunction()
            this.alertService.success(response.message);
          }else{
            this.alertService.danger(response.message);
          }
        }, error: (error: HttpErrorResponse) => {
          this.alertService.danger(error.error.message);
        }
      })
    }
  }


  // map
  @ViewChild('gmap', { static: true }) gmapElement!: ElementRef;
  autocomplete!: google.maps.places.Autocomplete;
  selectedLat: number = 0;
  selectedLng: number = 0;
  placeName: string = '';
  private bayonneDeliveryZone = [
    {lat:40.642, lng:-74.148},
    {lat:40.650, lng:-74.086},
    {lat:40.727, lng:-74.020},
    {lat:40.737, lng:-74.086},
    {lat:40.642, lng:-74.148}
  ];
  initAutocomplete(): void {
    const input = document.getElementById('addressInputAccount') as HTMLInputElement;
    this.autocomplete = new google.maps.places.Autocomplete(input, {
      componentRestrictions: { country: 'us' },
      fields: ['geometry', 'formatted_address', 'address_components']
    });

    this.autocomplete.addListener('place_changed', async () => {
      const place = this.autocomplete.getPlace();
      if (!place.geometry) {
        this.alertService.danger('Please select a valid address from the suggestions');
        return;
      }

      // Corrected condition with proper parentheses
      const inBayonne = place.address_components?.some(comp => 
        (comp.types.includes('locality') && ['Bayonne'].includes(comp.long_name)) ||
        (comp.types.includes('postal_code') && ['07002', '07305', '07304'].some(zip => comp.long_name.startsWith(zip))
      ));

      // console.log('Address Components:', place.address_components);
      // console.log('In Bayonne Check:', inBayonne);

      if (!inBayonne) {
        this.handleOutOfZone(input);
        return;
      }

      const location = place.geometry.location;
      const isInZone = await this.checkDeliveryZone(location.lat(), location.lng());
      
      if (!inBayonne) { //isInZone
        this.handleOutOfZone(input);
      } else {
        this.selectedLat = location.lat();
        this.selectedLng = location.lng();
        this.placeName = place.formatted_address;
        const address = place.formatted_address;
        this.newAddressForm.patchValue({ address: address, latitude: this.selectedLat.toString(), longitude: this.selectedLng.toString() });
      }
    });
  }
  private handleOutOfZone(input: HTMLInputElement): void {
    this.alertService.danger('Sorry, we only deliver within Bayonne, NJ');
    input.value = '';
    this.selectedLat = null;
    this.selectedLng = null;
    this.placeName = '';
  }
  private isPointInPolygon(point: {lat: number, lng: number}, polygon: any[]): boolean {
    // Ray-casting algorithm
    let inside = false;
    for (let i = 0, j = polygon.length - 1; i < polygon.length; j = i++) {
      const xi = polygon[i].lat, yi = polygon[i].lng;
      const xj = polygon[j].lat, yj = polygon[j].lng;
      
      const intersect = ((yi > point.lng) !== (yj > point.lng)) &&
        (point.lat < (xj - xi) * (point.lng - yi) / (yj - yi) + xi);
      if (intersect) inside = !inside;
    }
    return inside;
  }
  async checkDeliveryZone(lat: number, lng: number): Promise<boolean> {
    // console.log('Checking coordinates:', lat, lng);
    
    const inBounds = this.isInBayonneBounds(lat, lng);
    // console.log('In rough bounds:', inBounds);
    
    const inPolygon = this.isPointInPolygon({lat, lng}, this.bayonneDeliveryZone);
    // console.log('In precise polygon:', inPolygon);
    
    return inPolygon;
  }
  private isInBayonneBounds(lat: number, lng: number): boolean {
    // Simple rectangular bounds check first for performance
    return (
      lat >= 40.6412 && // Southern boundary
      lat <= 40.6689 && // Northern boundary
      lng >= -74.1147 && // Western boundary
      lng <= -74.0279   // Eastern boundary
    );
  }
  // initAutocomplete(): void {
  //   const input = document.getElementById('addressInputAccount') as HTMLInputElement;
  //   this.autocomplete = new google.maps.places.Autocomplete(input, {
  //     componentRestrictions: { country: 'us' },
  //     fields: ['geometry', 'formatted_address']
  //   });
  //   this.autocomplete.addListener('place_changed', () => {
  //     const place = this.autocomplete.getPlace();
  //     if (!place.geometry) {
  //       console.warn('Place has no geometry');
  //       return;
  //     }
  //     const location = place.geometry.location;
  //     this.selectedLat = location.lat();
  //     this.selectedLng = location.lng();
  //     this.placeName = place.formatted_address;
  //     console.log(this.selectedLat);
  //     console.log(this.selectedLng);
  //     console.log(place.formatted_address);
  //     const address = place.formatted_address;
  //     this.newAddressForm.patchValue({ address: address });
  //   });
  // }
  submitAddress() {
    if (this.newAddressForm.invalid) {
      this.newAddressForm.markAllAsTouched();
      this.alertService.danger('Please fill all required fields');
      return;
    }

    const address: any = {
      city_id: this.newAddressForm.value.city_id,
      address: this.newAddressForm.value.address,
      latitude: this.newAddressForm.value.latitude,
      longitude: this.newAddressForm.value.longitude
    };

    // Only add optional fields if they have values
    if (this.newAddressForm.value.building) {
      address.building = this.newAddressForm.value.building;
    }
    if (this.newAddressForm.value.floor) {
      address.floor = this.newAddressForm.value.floor;
    }
    if (this.newAddressForm.value.flat) {
      address.flat = this.newAddressForm.value.flat;
    }
    if (this.newAddressForm.value.special_mark) {
      address.special_mark = this.newAddressForm.value.special_mark;
    }

    this.isLoading = true;
    this.apiService.addAddress(address).subscribe({
      next: (response) => {
        this.alertService.success(response.message);
        this.myAddressesFunction(); // Refresh addresses list
        this.newAddressForm.reset();
        this.isLoading = false;
      },
      error: (error) => {
        this.alertService.danger(error.error?.message || 'Failed to add address');
        this.isLoading = false;
      }
    });
  }

  formatPhoneNumber(event: Event) {
    const input = event.target as HTMLInputElement;
    let value = input.value.replace(/\D/g, ''); // Remove all non-digits
    
    // Store raw value in the form control (without hyphens)
    // this.accountForm.get('sec_phone')?.setValue(value, { emitEvent: false });
    
    // Apply formatting (123-456-7891)
    if (value.length > 3 && value.length <= 6) {
        value = value.substring(0, 3) + '-' + value.substring(3);
    } else if (value.length > 6) {
        value = value.substring(0, 3) + '-' + value.substring(3, 6) + '-' + value.substring(6, 10);
    }
    
    // Update the displayed value
    input.value = value;
  }
  formatPhoneForDisplay(phone: string) {
    if (!phone) return '';
    const digits = phone.replace(/\D/g, '');
    if (digits.length <= 3) return digits;
    if (digits.length <= 6) return `${digits.substring(0, 3)}-${digits.substring(3)}`;
    return `${digits.substring(0, 3)}-${digits.substring(3, 6)}-${digits.substring(6, 10)}`;
  }
}
